import { createStore } from "vuex";
import { getUserInfo } from "@/service/canvas";
import { logout } from "@/service";
import { getGroupList } from "@/service/chat";

export default createStore({
  state: {
    drawSame: "",
    userInfo: {
      user_id: "",
      nickname: "",
      avatar: "",
      commission_is_open: 0,
      is_commission: 0,
      vip_expire_time: "",
      gaoji_vip_expire_time: "",
      balance: 0,
    },
    showChatSlider: document.documentElement.clientWidth >= 768,
    isLogin: false,
    sessions: [],
    currentSession: "",
    currentChatMsgHistory: [],
    chatMode: "",
    historyLoading: false,
    isMobile: false,
    showLogin: false,
    showUserInfo: false,
    showVip: false,
    drawUploadImgs: [],
  },
  getters: {
    isVip(state) {
      return !!(
        state.userInfo.vip_expire_time || state.userInfo.gaoji_vip_expire_time
      );
    },
    isSVip(state) {
      return !!state.userInfo.gaoji_vip_expire_time;
    },
    chatMode: (state) => {
      return (
        state.chatMode ||
        localStorage.getItem("gtpModel") ||
        "GPT-3.5-Turbo-16k模型"
      );
    },
  },
  mutations: {
    SET_AI_UPLOADS(state, data) {
      state.drawUploadImgs = data;
    },
    SET_DRAW_SAME(state, str) {
      state.drawSame = str;
    },
    SET_USER_INFO(state, info) {
      state.userInfo = info;
    },
    SET_CHAT_SLIDER(state, bool) {
      state.showChatSlider = bool;
    },
    SET_LOGIN(state, bool) {
      state.isLogin = bool;
    },
    SET_CURRENT_CHAT_MSG(state, data) {
      state.currentChatMsgHistory = data;
    },
    SET_CHAT_MODE(state, mode) {
      localStorage.setItem("gtpModel", mode);
      state.chatMode = mode;
    },
    SET_HISTORY_LOADING(state, bool) {
      state.historyLoading = bool;
    },
    SET_CURRENT_SESSION(state, data) {
      state.currentSession = data;
    },
    SET_IS_MOBILE(state, bool) {
      state.isMobile = bool;
    },
    SET_SESSIONS(state, data) {
      state.sessions = data;
    },
    SET_SHOW_LOGIN(state, bool) {
      state.showLogin = bool;
    },
    SET_SHOW_USERINFO(state, bool) {
      state.showUserInfo = bool;
    },
    SET_SHOW_VIP(state, bool) {
      state.showVip = bool;
    },
  },
  actions: {
    getUserInfo({ commit }) {
      return getUserInfo().then((res) => {
        if (!res.errno) {
          commit("SET_USER_INFO", res.data);
          commit("SET_LOGIN", true);
          commit("SET_SHOW_LOGIN", false);
          return true;
        }
        commit("SET_USER_INFO", {});
        commit("SET_LOGIN", false);
        commit("SET_SHOW_LOGIN", false);
        return false;
      });
    },
    logout({ commit }) {
      logout().then((res) => {
        if (!res.errno) {
          commit("SET_USER_INFO", {});
          document.cookie = "";
          location.reload();
        }
      });
    },
    getSessions({ commit }) {
      return getGroupList().then((res) => {
        if (!res.errno) {
          commit("SET_SESSIONS", res.data.list);
        }
      });
    },
  },
  modules: {},
});
